import { ContactQrcode } from "./types";
import { RootState } from "@store/store";
import { sortByOrder } from "@utils/array";

const orderContactQrcodes = (contactQrcodes: ContactQrcode[], state: RootState) => {
  contactQrcodes = sortByOrder(contactQrcodes);
  if (state.globalReducer.isLogin) {
    // 登录状态下优先用户手机前置
    const phoneCountryCode = localStorage.getItem("phonePrefix") || state.globalReducer.userInfo.phoneCountryCode;
    const selectIndex = contactQrcodes.findIndex((item: any) => item.phoneCode === phoneCountryCode);
    if (selectIndex >= 0) {
      return [
        contactQrcodes[selectIndex],
        ...contactQrcodes.slice(0, selectIndex),
        ...contactQrcodes.slice(selectIndex + 1),
      ];
    }
    return contactQrcodes;
  } else {
    // 未登录状态下优先当前语言
    const phonePrefix = localStorage.getItem("phonePrefix");
    const selectIndex = contactQrcodes.findIndex((item: any) => item.phoneCode === phonePrefix);
    if (selectIndex >= 0) {
      return [
        contactQrcodes[selectIndex],
        ...contactQrcodes.slice(0, selectIndex),
        ...contactQrcodes.slice(selectIndex + 1),
      ];
    }
    return contactQrcodes;
  }
};

// 按照国家取其中一个二维码
// 优先根据手机号，其次设备ID，再其次随机
const combineQrcodeByCountry = (groupChatQrcodes: ContactQrcode[], state: RootState) => {
  let groupChatQrcodeMap: any = {};
  for (let qrcode of groupChatQrcodes) {
    if (groupChatQrcodeMap[qrcode.country]) {
      groupChatQrcodeMap[qrcode.country].push(qrcode);
    } else {
      groupChatQrcodeMap[qrcode.country] = [qrcode];
    }
  }

  let newGroupChatQrcodes = [];
  for (let country of Object.keys(groupChatQrcodeMap)) {
    const qrcodes = groupChatQrcodeMap[country];
    if (qrcodes.length === 1) {
      newGroupChatQrcodes.push(qrcodes[0]);
    } else if (qrcodes.length > 1) {
      const symbol =
        state.globalReducer.userInfo.phoneNumber ||
        state.globalReducer.deviceId ||
        String(Math.floor(Math.random() * 100));
      const selectIndex = symbol.charCodeAt(symbol.length - 1) % qrcodes.length;
      newGroupChatQrcodes.push(qrcodes[selectIndex]);
    }
  }
  return newGroupChatQrcodes;
};

export const selectTiktokQrcodes = (state: RootState) => {
  let tiktokQrcodes = state.configReducer.contactQrcode.filter((item) => item.type === "TikTok");
  return orderContactQrcodes(tiktokQrcodes, state);
};

export const selectGroupChatQrcodes = (state: RootState) => {
  let groupChatQrcodes = state.configReducer.contactQrcode.filter((item) => item.type === "Group Chat");
  groupChatQrcodes = combineQrcodeByCountry(groupChatQrcodes, state);
  return orderContactQrcodes(groupChatQrcodes, state);
};

// 当前展示的客服群二维码
export const selectCurrentGroupChat = (state: RootState) => {
  let groupChatQrcodes = state.configReducer.contactQrcode.filter((item) => item.type === "Group Chat");
  groupChatQrcodes = combineQrcodeByCountry(groupChatQrcodes, state);
  groupChatQrcodes = orderContactQrcodes(groupChatQrcodes, state);
  if (groupChatQrcodes && groupChatQrcodes.length > 0) {
    return groupChatQrcodes[0];
  }
};
